import { useServiceTemplateApi } from '~/hooks/useServiceTemplateApi';
import { serviceTemplateModel } from '~/models';
import { QueryKeys } from '../queryKeys';
import { useQueryState } from '../useQueryState';
export const useActiveServiceTemplates = function useActiveServiceTemplates() {
    let { refreshOnMount } = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    const serviceTemplateApi = useServiceTemplateApi();
    const { data, isLoading, isBackgroundLoading, isFetching, error, refresh } = useQueryState({
        queryKey: [
            QueryKeys.ActiveServices
        ],
        queryFn: ()=>serviceTemplateApi.getActiveServicesAndBundles(),
        select: (data)=>({
                all: data,
                serviceTemplates: data.filter((s)=>!serviceTemplateModel.isBundle(s)),
                bundles: data.filter(serviceTemplateModel.isBundle)
            }),
        refreshOnHookMount: refreshOnMount
    });
    return {
        serviceTemplates: data === null || data === void 0 ? void 0 : data.serviceTemplates,
        bundles: data === null || data === void 0 ? void 0 : data.bundles,
        data: data === null || data === void 0 ? void 0 : data.all,
        isLoading,
        isBackgroundLoading,
        isFetching,
        error,
        refresh
    };
};
